import React from 'react';
import { useSelector } from 'react-redux';

import { redirectToUrl } from '@gumtree/ui-library/src/utils/browser-service';

import { SpellingSuggestion, H1Bold } from './index.style';
import type { SrpState } from '../../reducers';
import { CORRECTED_KEYWORD_FOR_REDO, CORRECTED_KEYWORD_FOR_UNDO } from './constants';

const KeywordSpellingSuggestion = () => {
    const {
        resultsPage: { keywordCorrection },
        searchBar,
    } = useSelector((data: SrpState) => data);

    const isInitialAutoCorrection =
        Boolean(keywordCorrection.autoCorrectInitial) &&
        Boolean(keywordCorrection.autoCorrectInitial?.correctedKeyword);

    const shouldShowSpellingSuggestion =
        isInitialAutoCorrection || Boolean(keywordCorrection.autoCorrectUndone);

    const clickOutQuery = isInitialAutoCorrection
        ? keywordCorrection.autoCorrectInitial?.originalKeyword
        : keywordCorrection.autoCorrectUndone?.correctedKeyword;

    return shouldShowSpellingSuggestion ? (
        <SpellingSuggestion
            onClick={() => {
                if (clickOutQuery) {
                    const clickOutUrlQueryParams = new URLSearchParams();
                    clickOutUrlQueryParams.set('search_location', searchBar.location.value);
                    clickOutUrlQueryParams.set('q', clickOutQuery);
                    if (keywordCorrection.autoCorrectInitial?.correctedKeyword) {
                        clickOutUrlQueryParams.set(
                            CORRECTED_KEYWORD_FOR_UNDO,
                            keywordCorrection.autoCorrectInitial?.correctedKeyword
                        );
                    }

                    if (keywordCorrection.autoCorrectUndone?.correctedKeyword) {
                        clickOutUrlQueryParams.set(
                            CORRECTED_KEYWORD_FOR_REDO,
                            keywordCorrection.autoCorrectUndone?.correctedKeyword
                        );
                    }

                    redirectToUrl(`/search?${clickOutUrlQueryParams}`);
                }
            }}
        >
            Search instead for <H1Bold>{clickOutQuery}</H1Bold>
        </SpellingSuggestion>
    ) : (
        <></>
    );
};

export default KeywordSpellingSuggestion;
